import React from 'react';
// @ts-ignore
import Config from 'Config';
import { Elements, StripeProvider } from 'react-stripe-elements';
import ErrorReporter from 'app/components/ErrorReporter';
import LoadingIndicator from 'components/LoadingIndicator';
import StripeAPI from 'lib/StripeAPI';

type Props = {
  children: React.ReactNode;
};

type State = {
  stripeLoaded: boolean;
  loadFailed: boolean;
};

export default class StripeContainer extends React.Component<Props, State> {
  state = {
    stripeLoaded: false,
    loadFailed: false,
  };

  componentDidMount() {
    StripeAPI.load().then(
      () => {
        this.setState({ stripeLoaded: true, loadFailed: false });
      },
      () => {
        this.setState({ stripeLoaded: true, loadFailed: true });
      }
    );
  }

  render() {
    if (!this.state.stripeLoaded) return <LoadingIndicator />;
    if (this.state.loadFailed)
      return (
        <ErrorReporter error="Error loading Stripe in the coaching StripeContainer">
          There was a problem loading this page. Please try again and contact coaching@remind.com if
          the problem persists.
          {this.props.children}
        </ErrorReporter>
      );
    return (
      <StripeProvider apiKey={Config.Environment.COACHING_STRIPE_PUBLISHABLE_KEY}>
        <Elements>{this.props.children}</Elements>
      </StripeProvider>
    );
  }
}
